import { render, staticRenderFns } from "./dispensation2.vue?vue&type=template&id=24233561&scoped=true"
import script from "./dispensation2.vue?vue&type=script&lang=js"
export * from "./dispensation2.vue?vue&type=script&lang=js"
import style0 from "./dispensation2.vue?vue&type=style&index=0&id=24233561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24233561",
  null
  
)

export default component.exports